import { createContext } from 'react';

const PromotionsContext = createContext(void 0);

PromotionsContext.displayName = 'context(promotions)';

export default PromotionsContext;